import { Component, ViewChild, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatDialogRef } from '@angular/material/dialog';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';

@Component({
    selector: 'ldw-qr-code',
    templateUrl: './qr-code.component.html',
    styleUrls: ['./qr-code.component.css'],
    standalone: false
})
export class QRCodeComponent {
  dialogRef = inject<MatDialogRef<QRCodeComponent>>(MatDialogRef);

  static lastSelectedDeviceId: string | undefined = undefined;
  initializing: boolean;
  hasDevices: boolean | undefined = undefined;
  hasPermission: boolean | undefined = undefined;
  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  availableDevices: MediaDeviceInfo[] = [];

  @ViewChild('scanner', { static: false }) scanner!: ZXingScannerComponent;

  constructor() {
    this.initializing = true;
  }

  get currentDevice(): MediaDeviceInfo | undefined {
    if (this.scanner == null) {
      return undefined;
    }
    return this.scanner.device;
  }

  get showNotFound(): boolean {
    return !this.initializing && this.hasDevices === false;
  }

  get accessError(): boolean {
    return !this.initializing && this.hasDevices === undefined;
  }

  get waitPermission(): boolean {
    return !this.initializing && this.hasPermission === undefined;
  }

  get permissionDenied(): boolean {
    return !this.initializing && this.hasPermission === false;
  }

  isChecked(device: MediaDeviceInfo): boolean {
    if (this.initializing || device == null) return false;
    if (this.currentDevice === undefined) return false;
    return device.deviceId === this.currentDevice.deviceId;
  }

  selectCam(device: MediaDeviceInfo) {
    // console.log('select cam: new device' + device?.label ?? 'undefined');
    // console.log('current device' + this.currentDevice?.label ?? 'undefined');

    if (this.currentDevice != device) {
      this.scanner.device = device;
      // console.log('set to ' + device?.label ?? 'undefined');
    }
    QRCodeComponent.lastSelectedDeviceId = device?.deviceId ?? undefined;
  }

  onCamerasFound(devices: MediaDeviceInfo[]) {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
    /*
    this seems not to work, as the selection is overriden by an automatic selection of backcamera
    https://github.com/zxing-js/ngx-scanner/issues/437
    https://github.com/zxing-js/ngx-scanner/issues/382
    if (this.hasDevices) {
      if (QRCodeComponent.lastSelectedDeviceId != undefined) {
        const last = this.availableDevices.find((d) => d.deviceId == QRCodeComponent.lastSelectedDeviceId);

        if (last != null) {
          this.selectCam(last);
          this.initializing = false;
          return;
        }
      }
      if (this.availableDevices.length == 1) {
        this.selectCam(this.availableDevices[0]);
      }
    }

     */
    this.initializing = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  camerasNotFoundHandler(e: any) {
    // todo: deal with error when no camera was found
    this.availableDevices = [];
    this.hasDevices = false;
    this.initializing = false;
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
    this.initializing = false;
  }

  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(event: MatSlideToggleChange) {
    this.torchEnabled = event.checked;
  }

  close() {
    this.dialogRef.close();
  }

  onCodeResult(found: string) {
    this.dialogRef.close(found);
  }
}
